import { render, staticRenderFns } from "./MaxList.vue?vue&type=template&id=30a55f5a&scoped=true&"
import script from "./MaxList.vue?vue&type=script&lang=js&"
export * from "./MaxList.vue?vue&type=script&lang=js&"
import style0 from "./MaxList.vue?vue&type=style&index=0&id=30a55f5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a55f5a",
  null
  
)

export default component.exports